import { mockOfficeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-record-card';
const CONV_ID = 'conv-1';
const MD_BLOCK_ID = 'blk-rc-md';
const CARD_BLOCK_ID = 'blk-rc-card';
const markdownText = 'Here is the inspection record you requested:';
const recordCardBlock = {
    type: 'record_card',
    block_id: CARD_BLOCK_ID,
    block_index: 1,
    resource_type: 'inspection',
    resource_id: 'insp-3200',
    title: 'Inspection #3200 — Annual Sprinkler',
    url: '/inspections/3200',
    fields: [
        { label: 'Building', value: 'Building A — Main Office' },
        { label: 'Status', value: 'Completed' },
        { label: 'Date', value: '2026-01-15', format: 'date' },
        { label: 'Technician', value: 'Jane Smith' },
        { label: 'Deficiencies', value: '2' }
    ],
    status: { label: 'Completed', color: '#2ECC71' }
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(recordCardBlock, 100),
    makeStreamEnd(RESPONSE_ID, 2, mockOfficeAgent)
];
export const scenario = {
    name: 'Office Assistant — Record Card with Status',
    description: 'Streaming markdown followed by a record_card block showing an inspection with status badge and fields.',
    conversations: mockConversations,
    userMessage: 'Show me inspection 3200',
    agentIdentity: mockOfficeAgent,
    sseSequence
};
